import React, { useContext } from 'react'

import { compose } from 'recompose'

import { MOC_ONBOARDING_FLOW } from 'app-constants'
import { FunnelName } from 'generated/types'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FunnelContext } from 'utils/FunnelContext'

import CheckingFunding from './Checking'
import DefaultFunding from './Default'

type Props = WithFlowRouterProps

const enhance = compose<Props, {}>(withFlowRouter)

const Funding = enhance(({ flow }) => {
  const { isDynamicFunnelEnabled, metadata } = useContext(FunnelContext)
  const shouldShowCheckingFunding =
    (isDynamicFunnelEnabled && metadata.name === FunnelName.MightyOakCard) ||
    flow === MOC_ONBOARDING_FLOW
  return shouldShowCheckingFunding ? <CheckingFunding /> : <DefaultFunding />
})

export default Funding
